import { atom } from '@reatom/framework'
import { withLocalStorage } from '@reatom/persist-web-storage'

import { STORAGE_PREFIX } from './constants'

export * as Api from './api'
export * from './environment'
export * from './config'
export * from './constants'
export * from './core'
export * from './hooks'

const DEBUG_STORAGE_KEY = `${STORAGE_PREFIX}/v1/debugScreen`

export const showDemoScreenAtom = atom(false, 'showDemoScreenAtom')
export const showDebugScreenAtom = atom(false, 'showDebugScreenAtom').pipe(
  withLocalStorage(DEBUG_STORAGE_KEY),
)
